import React from 'react';
import { ReactP5Wrapper } from 'react-p5-wrapper';

const Sketch = p5 => {
  let angleOffset = 0;

  p5.setup = () => {
    p5.createCanvas(200, 200);
    p5.noFill();
    p5.stroke(255);
  };

  p5.draw = () => {
    p5.clear();
    p5.translate(p5.width / 2, p5.height / 2);
    angleOffset += 0.005; // Slowly increase the angle offset

    // Draw multiple polygons with varying sizes and rotations
    for (let i = 0; i < 5; i++) {
      p5.push();
      p5.rotate(angleOffset + i);
      drawPolygon(0, 0, 10 + i * 8, 6, p5.sin(p5.frameCount * 0.01 + i) * 1);
      p5.pop();
    }
  };

  function drawPolygon(x, y, radius, npoints, dynamic) {
    let angle = p5.TWO_PI / npoints;
    let halfAngle = angle / 2.0;
    p5.beginShape();
    for (let a = 0; a < p5.TWO_PI; a += angle) {
      let sx = x + p5.cos(a) * (radius + dynamic);
      let sy = y + p5.sin(a) * (radius + dynamic);
      p5.vertex(sx, sy);
      sx = x + p5.cos(a + halfAngle) * (radius + dynamic) * 0.6;
      sy = y + p5.sin(a + halfAngle) * (radius + dynamic) * 0.6;
      p5.vertex(sx, sy);
    }
    p5.endShape(p5.CLOSE);
  }
};

const GeometricPattern = () => (
  <div id="geometric-pattern">
    <ReactP5Wrapper sketch={Sketch} />
  </div>
);

export default GeometricPattern;
